import {  html, unsafeCSS, css } from 'lit';
import { property } from 'lit/decorators.js';
import tailwindCSS from '../../../index.css?inline';
import '../forms/form-render';
import { TemplateMixin } from '../../../core/mixins/template-mixin';
import './section-page'
import { CanvaPageBase } from './base/canvas-page.base';

export class CanvasPage extends TemplateMixin(CanvaPageBase) {
   static readonly is = 'canvas-page';
  static styles = [
    unsafeCSS(tailwindCSS),
    css`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .dialog-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        backdrop-filter: blur(2px);
      }

      .custom-dialog {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 90vw;
    max-height: 90vh;
    min-width: 300px;
    min-height: 200px;
   
    animation: dialog-appear 0.3s ease-out;
}

      .custom-dialog-with-scroll-hide {
        background: white;
        border-radius: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        max-width: 90vw;
        max-height: 90vh;
        min-width: 300px;
        min-height: 200px;
        overflow: auto; 
        animation: dialog-appear 0.3s ease-out;
      
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 和 Edge */
        }

        .custom-dialog-with-scroll-hide::-webkit-scrollbar {
            display: none; /* Chrome, Safari 和 Opera */
        }

      @keyframes dialog-appear {
        from {
          opacity: 0;
          transform: scale(0.9) translateY(-10px);
        }
        to {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }

      /* Ensure main content is behind dialog */
      .main-content {
        position: relative;
        z-index: 1;
      }

      /* When dialog is open, disable scrolling on main content */
      .dialog-open {
        overflow: hidden;
        height: 100vh;
      }
    `
  ];

  @property({ type: Object })
  interfaceData: any = null;

  @property({ type: Object })
  pageGroup: any = null;

  @property({ type: String })
  view: string = 'main';

   firstUpdated() {
    super.firstUpdated();
    this.setupEventListeners();
  }
  
  private setupEventListeners(): void {
    // Listen for the close event from dialpad
    this.addEventListener('close-dialpad-modal', this.handleDialpadClose.bind(this));
  }
  
  private handleDialpadClose(_event: CustomEvent): void {
    
    // Call hideSectionPage to close the modal
    this.hideSectionPage();
    
    // Also close the dialog if open
    if (this.view === 'dialog') {
      this.view = 'main';
      this.requestUpdate();
    }
  }
  
  disconnectedCallback() {
    // Clean up event listeners
    this.removeEventListener('close-dialpad-modal', this.handleDialpadClose.bind(this));
    super.disconnectedCallback();
  }

  // @state()
  // private dialogOpen: boolean = false;

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    if (changedProperties.has('view')) {
      this.dialogOpen = this.view === 'dialog';
      
      // Add/remove class to body for global styling
      if (this.view === 'dialog') {
        document.body.classList.add('dialog-open');
      } else {
        document.body.classList.remove('dialog-open');
      }
      
      this.requestUpdate();
    }
  }

  // private hexToRgbA(hex: string): string {
  //   let c;
  //   if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
  //     c = hex.substring(1).split('');
  //     if (c.length == 3) {
  //       c = [c[0], c[0], c[1], c[1], c[2], c[2]];
  //     }
  //     c = '0x' + c.join('');
  //     return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', 0.15)';
  //   }
  //   throw new Error('Bad Hex');
  // }

  private closeDialog() {
    this.hideSectionPage()
    this.requestUpdate()
   
  }

   _viewList(_evt: any) {
    if (!this.dialogsStack.length) {
      this.view = 'list';
      this.updateLocationHash();
    } else {
      const args = this.dialogsStack.pop();
      const dialog = this.shadowRoot.querySelector('#dialog');

      dialog.payload = args[0];
      dialog.params = args[1];
      dialog.loading = false;
    }
  }

  render() {
    // const newColor = getComputedStyle(document.documentElement).getPropertyValue('--md-sys-color-primary').trim();
    // const bgColor = this.hexToRgbA(newColor);

    if (!this.interfaceData || !this.pageGroup) {
      return html`
        <div class="flex items-center justify-center h-full min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
  <div class="text-center p-8 max-w-md">
    <!-- Animated Icon -->
    <div class="relative mb-6">
      <div class="w-20 h-20 mx-auto bg-gradient-to-r from-rose-400 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg shadow-pink-500/25 rotate-45 transform-gpu">
        <svg class="w-10 h-10 text-white -rotate-45" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
      <div class="absolute -inset-2 bg-rose-500/10 rounded-3xl blur-sm animate-pulse"></div>
    </div>

    <!-- Text Content -->
    <h2 class="text-2xl font-bold text-gray-900 mb-3 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
      Content Unavailable
    </h2>
    
    <p class="text-gray-600 mb-6 leading-relaxed">
      We couldn't load the interface data at this moment. This might be temporary - please try refreshing the page.
    </p>

    <!-- Action Button -->
    <button 
  onclick="window.location.href = '/';"
  class="group relative inline-flex items-center px-6 py-3 bg-gradient-to-r from-slate-900 to-gray-800 text-white font-medium rounded-xl hover:from-gray-800 hover:to-slate-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 transform-gpu"
>
  <svg class="w-5 h-5 mr-2 group-hover:rotate-180 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
  </svg>
  Go to Homepage
  <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
</button>

    <!-- Decorative Elements -->
    <div class="mt-8 flex justify-center space-x-2">
      <div class="w-2 h-2 bg-gray-300 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
      <div class="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
      <div class="w-2 h-2 bg-gray-500 rounded-full animate-bounce" style="animation-delay: 0.3s"></div>
    </div>
  </div>
</div>
      `;
    }

    return html`
      <!-- Main Content -->
      <div class="main-content w-full min-h-screen">
        ${this.pageGroup.pages.map((page: any) => html`        
          <section class="w-full py-0 min-h-screen" id=${page.id}>
            
              <div class="w-full justify-center flex-wrap min-h-screen">
                ${page._feedList.map((feed: any) => html`
                  <div class="${this._gridClasses(feed)} p-0">
                    <form-render 
                      .template="canvas"
                      .feed="${feed}" 
                      .top="${this._computeTop()}" 
                      .params="${this.parseParams()}"
                      class="w-full"
                    ></form-render>
                  </div>
                `)}
              </div>
         
          </section>
        `)}
      </div>

      <!-- Dialog Overlay -->
       ${this.view == "dialog" ? this.renderDialog() : html``}
     
    `;
  }

  private renderDialog() {
        return html`
            <div class="dialog-backdrop" @click=${this.closeDialog}>
                <div class="custom-dialog" @click=${(e: Event) => e.stopPropagation()}>
                    <section-page 
                id="dialog" 
                .isSectionPage=${true} 
                .closeDialog=${this.closeDialog.bind(this)} 
                @view-list=${this._viewList} 
                .queue=${this.dialogServicesQueue}
              ></section-page>
                </div>
            </div>
        `;
    }

    // private getDialogPayload() {
    //     // If you have a payload to pass, implement this method
    //     return null;
    // }

  // private _gridClasses(feed: any): string {
  //   const sizeMap: { [key: string]: string } = {
  //     'is-full': 'col-span-full w-full',
  //     'is-half': 'md:col-span-6 col-span-full',
  //     'is-one-third': 'md:col-span-4 col-span-full',
  //     'is-two-thirds': 'md:col-span-8 col-span-full',
  //     'is-one-quarter': 'md:col-span-3 col-span-full',
  //     'is-three-quarters': 'md:col-span-9 col-span-full'
  //   };
  //   return sizeMap[feed.size] || 'col-span-full w-full';
  // }

  // private _getGridColumns(page: any): string {
  //   const formCount = page.pageInputGroups?.length || 0;
    
  //   if (formCount === 1) return 'grid-cols-1';
  //   if (formCount === 2) return 'md:grid-cols-2 grid-cols-1';
  //   if (formCount <= 4) return 'md:grid-cols-2 lg:grid-cols-3 grid-cols-1';
  //   return 'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-cols-1';
  // }

  private _computeTop(): number {
    return 0;
  }


}

customElements.define('canvas-page', CanvasPage as any);